import { useState, useCallback, useEffect, useRef } from "react";

// ═════════════════════════════════════════════════════════════════════════════
//  CONFIGURATION — remplacez par votre URL PythonAnywhere
// ═════════════════════════════════════════════════════════════════════════════
const API_URL = "https://ousmane.pythonanywhere.com/save-responses";

const FORM_TITLE = "Questionnaire de positionnement";
const FORM_SUB   = "Formation Excel Avancé — Tableaux de Bord Décisionnels · Proxima Technologies";

// ═════════════════════════════════════════════════════════════════════════════
//  3 SVG DASHBOARDS POUR LE CAROUSEL
// ═════════════════════════════════════════════════════════════════════════════
const DASHBOARDS = [
  {
    label: "Tableau de bord RH",
    svg: `<svg width="100%" viewBox="0 0 680 300" xmlns="http://www.w3.org/2000/svg">
  <rect width="680" height="300" fill="#1E2A5E"/>
  <rect width="680" height="4" fill="#E8440A"/>
  <text x="24" y="32" font-family="Arial,sans-serif" font-size="13" fill="#C8D8F0" font-weight="700">Tableau de bord RH</text>
  <text x="24" y="48" font-family="Arial,sans-serif" font-size="10" fill="#4A6090">Effectifs · Absences · Formations · Masse salariale</text>
  <rect x="24" y="60" width="140" height="62" rx="8" fill="#253570"/>
  <rect x="24" y="60" width="3" height="62" rx="1.5" fill="#E8440A"/>
  <text x="36" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">Effectif total</text>
  <text x="36" y="104" font-family="Arial,sans-serif" font-size="26" fill="#FFFFFF" font-weight="700">1 248</text>
  <text x="36" y="116" font-family="Arial,sans-serif" font-size="9" fill="#4ADE80">+12 ce mois</text>
  <rect x="174" y="60" width="140" height="62" rx="8" fill="#253570"/>
  <rect x="174" y="60" width="3" height="62" rx="1.5" fill="#E8440A"/>
  <text x="186" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">Taux d'absentéisme</text>
  <text x="186" y="104" font-family="Arial,sans-serif" font-size="26" fill="#FFFFFF" font-weight="700">3.2%</text>
  <text x="186" y="116" font-family="Arial,sans-serif" font-size="9" fill="#FCA5A5">+0.4% vs N-1</text>
  <rect x="324" y="60" width="140" height="62" rx="8" fill="#253570"/>
  <rect x="324" y="60" width="3" height="62" rx="1.5" fill="#E8440A"/>
  <text x="336" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">Masse salariale</text>
  <text x="336" y="104" font-family="Arial,sans-serif" font-size="26" fill="#FFFFFF" font-weight="700">847M</text>
  <text x="336" y="116" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8">FCFA / mois</text>
  <rect x="474" y="60" width="182" height="62" rx="8" fill="#253570"/>
  <rect x="474" y="60" width="3" height="62" rx="1.5" fill="#1D9E75"/>
  <text x="486" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">Taux de formation</text>
  <text x="486" y="104" font-family="Arial,sans-serif" font-size="26" fill="#FFFFFF" font-weight="700">68%</text>
  <text x="486" y="116" font-family="Arial,sans-serif" font-size="9" fill="#4ADE80">Objectif : 75%</text>
  <rect x="24" y="136" width="310" height="142" rx="8" fill="#253570"/>
  <text x="40" y="158" font-family="Arial,sans-serif" font-size="11" fill="#C8D8F0" font-weight="600">Pyramide des âges</text>
  <rect x="40" y="170" width="278" height="8" rx="3" fill="#334475"/>
  <rect x="40" y="170" width="230" height="8" rx="3" fill="#378ADD"/>
  <text x="278" y="178" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8" text-anchor="end">25-34 ans</text>
  <rect x="40" y="184" width="278" height="8" rx="3" fill="#334475"/>
  <rect x="40" y="184" width="195" height="8" rx="3" fill="#1D9E75"/>
  <text x="278" y="192" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8" text-anchor="end">35-44 ans</text>
  <rect x="40" y="198" width="278" height="8" rx="3" fill="#334475"/>
  <rect x="40" y="198" width="145" height="8" rx="3" fill="#E8440A"/>
  <text x="278" y="206" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8" text-anchor="end">45-54 ans</text>
  <rect x="40" y="212" width="278" height="8" rx="3" fill="#334475"/>
  <rect x="40" y="212" width="80" height="8" rx="3" fill="#EF9F27"/>
  <text x="278" y="220" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8" text-anchor="end">55+ ans</text>
  <rect x="40" y="226" width="278" height="8" rx="3" fill="#334475"/>
  <rect x="40" y="226" width="110" height="8" rx="3" fill="#7F77DD"/>
  <text x="278" y="234" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8" text-anchor="end">18-24 ans</text>
  <text x="40" y="260" font-family="Arial,sans-serif" font-size="9" fill="#4A6090">Ancienneté moy.</text>
  <text x="40" y="273" font-family="Arial,sans-serif" font-size="16" fill="#FFFFFF" font-weight="700">7.4 ans</text>
  <text x="140" y="260" font-family="Arial,sans-serif" font-size="9" fill="#4A6090">Turn-over annuel</text>
  <text x="140" y="273" font-family="Arial,sans-serif" font-size="16" fill="#FCA5A5" font-weight="700">8.1%</text>
  <text x="240" y="260" font-family="Arial,sans-serif" font-size="9" fill="#4A6090">Recrutements</text>
  <text x="240" y="273" font-family="Arial,sans-serif" font-size="16" fill="#4ADE80" font-weight="700">+24</text>
  <rect x="344" y="136" width="312" height="142" rx="8" fill="#253570"/>
  <text x="360" y="158" font-family="Arial,sans-serif" font-size="11" fill="#C8D8F0" font-weight="600">Absences par service (jours)</text>
  <line x1="360" y1="258" x2="636" y2="258" stroke="#334475" stroke-width="0.5"/>
  <rect x="368" y="220" width="32" height="38" rx="3" fill="#E8440A"/><text x="384" y="270" font-family="Arial,sans-serif" font-size="8" fill="#6B85B8" text-anchor="middle">RH</text>
  <rect x="412" y="200" width="32" height="58" rx="3" fill="#378ADD"/><text x="428" y="270" font-family="Arial,sans-serif" font-size="8" fill="#6B85B8" text-anchor="middle">Finance</text>
  <rect x="456" y="230" width="32" height="28" rx="3" fill="#1D9E75"/><text x="472" y="270" font-family="Arial,sans-serif" font-size="8" fill="#6B85B8" text-anchor="middle">IT</text>
  <rect x="500" y="210" width="32" height="48" rx="3" fill="#EF9F27"/><text x="516" y="270" font-family="Arial,sans-serif" font-size="8" fill="#6B85B8" text-anchor="middle">Ops</text>
  <rect x="544" y="235" width="32" height="23" rx="3" fill="#7F77DD"/><text x="560" y="270" font-family="Arial,sans-serif" font-size="8" fill="#6B85B8" text-anchor="middle">Comm</text>
  <rect x="588" y="218" width="32" height="40" rx="3" fill="#D85A30"/><text x="604" y="270" font-family="Arial,sans-serif" font-size="8" fill="#6B85B8" text-anchor="middle">Ventes</text>
  <text x="656" y="290" font-family="Arial,sans-serif" font-size="8" fill="#4A6090" text-anchor="end">Proxima Technologies</text>
</svg>`,
  },
  {
    label: "Tableau de bord Financier",
    svg: `<svg width="100%" viewBox="0 0 680 300" xmlns="http://www.w3.org/2000/svg">
  <rect width="680" height="300" fill="#0D1B2A"/>
  <rect width="680" height="4" fill="#E8440A"/>
  <text x="24" y="32" font-family="Arial,sans-serif" font-size="13" fill="#C8D8F0" font-weight="700">Tableau de bord Financier</text>
  <text x="24" y="48" font-family="Arial,sans-serif" font-size="10" fill="#4A6090">Budget · Réalisé · Écarts · Trésorerie</text>
  <rect x="24" y="60" width="148" height="62" rx="8" fill="#152232"/>
  <rect x="24" y="60" width="3" height="62" rx="1.5" fill="#E8440A"/>
  <text x="36" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">CA Réalisé (FCFA)</text>
  <text x="36" y="104" font-family="Arial,sans-serif" font-size="22" fill="#FFFFFF" font-weight="700">2.4 Mds</text>
  <text x="36" y="116" font-family="Arial,sans-serif" font-size="9" fill="#4ADE80">↑ 14% vs N-1</text>
  <rect x="182" y="60" width="148" height="62" rx="8" fill="#152232"/>
  <rect x="182" y="60" width="3" height="62" rx="1.5" fill="#378ADD"/>
  <text x="194" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">Budget consommé</text>
  <text x="194" y="104" font-family="Arial,sans-serif" font-size="22" fill="#FFFFFF" font-weight="700">68.4%</text>
  <text x="194" y="116" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8">Reste : 31.6%</text>
  <rect x="340" y="60" width="148" height="62" rx="8" fill="#152232"/>
  <rect x="340" y="60" width="3" height="62" rx="1.5" fill="#1D9E75"/>
  <text x="352" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">Résultat net</text>
  <text x="352" y="104" font-family="Arial,sans-serif" font-size="22" fill="#4ADE80" font-weight="700">+312 M</text>
  <text x="352" y="116" font-family="Arial,sans-serif" font-size="9" fill="#4ADE80">Marge : 13%</text>
  <rect x="498" y="60" width="158" height="62" rx="8" fill="#152232"/>
  <rect x="498" y="60" width="3" height="62" rx="1.5" fill="#EF9F27"/>
  <text x="510" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">DSO (délai encais.)</text>
  <text x="510" y="104" font-family="Arial,sans-serif" font-size="22" fill="#EF9F27" font-weight="700">42 j</text>
  <text x="510" y="116" font-family="Arial,sans-serif" font-size="9" fill="#FCA5A5">Objectif : 35j</text>
  <rect x="24" y="136" width="400" height="142" rx="8" fill="#152232"/>
  <text x="40" y="157" font-family="Arial,sans-serif" font-size="11" fill="#C8D8F0" font-weight="600">Budget vs Réalisé par service</text>
  <line x1="40" y1="268" x2="408" y2="268" stroke="#1E3050" stroke-width="0.5"/>
  <line x1="40" y1="248" x2="408" y2="248" stroke="#1E3050" stroke-width="0.5"/>
  <line x1="40" y1="228" x2="408" y2="228" stroke="#1E3050" stroke-width="0.5"/>
  <line x1="40" y1="208" x2="408" y2="208" stroke="#1E3050" stroke-width="0.5"/>
  <rect x="52" y="220" width="20" height="48" rx="2" fill="#378ADD" opacity="0.7"/>
  <rect x="76" y="232" width="20" height="36" rx="2" fill="#E8440A"/>
  <rect x="114" y="210" width="20" height="58" rx="2" fill="#378ADD" opacity="0.7"/>
  <rect x="138" y="218" width="20" height="50" rx="2" fill="#E8440A"/>
  <rect x="176" y="225" width="20" height="43" rx="2" fill="#378ADD" opacity="0.7"/>
  <rect x="200" y="240" width="20" height="28" rx="2" fill="#1D9E75"/>
  <rect x="238" y="215" width="20" height="53" rx="2" fill="#378ADD" opacity="0.7"/>
  <rect x="262" y="222" width="20" height="46" rx="2" fill="#E8440A"/>
  <rect x="300" y="230" width="20" height="38" rx="2" fill="#378ADD" opacity="0.7"/>
  <rect x="324" y="238" width="20" height="30" rx="2" fill="#1D9E75"/>
  <rect x="362" y="218" width="20" height="50" rx="2" fill="#378ADD" opacity="0.7"/>
  <rect x="386" y="228" width="20" height="40" rx="2" fill="#E8440A"/>
  <text x="62" y="280" font-family="Arial,sans-serif" font-size="8" fill="#4A6090" text-anchor="middle">RH</text>
  <text x="128" y="280" font-family="Arial,sans-serif" font-size="8" fill="#4A6090" text-anchor="middle">Finance</text>
  <text x="190" y="280" font-family="Arial,sans-serif" font-size="8" fill="#4A6090" text-anchor="middle">IT</text>
  <text x="250" y="280" font-family="Arial,sans-serif" font-size="8" fill="#4A6090" text-anchor="middle">Ops</text>
  <text x="314" y="280" font-family="Arial,sans-serif" font-size="8" fill="#4A6090" text-anchor="middle">Comm</text>
  <text x="376" y="280" font-family="Arial,sans-serif" font-size="8" fill="#4A6090" text-anchor="middle">Ventes</text>
  <rect x="40" y="290" width="8" height="6" rx="1" fill="#378ADD" opacity="0.7"/>
  <text x="52" y="296" font-family="Arial,sans-serif" font-size="8" fill="#6B85B8">Budget</text>
  <rect x="90" y="290" width="8" height="6" rx="1" fill="#E8440A"/>
  <text x="102" y="296" font-family="Arial,sans-serif" font-size="8" fill="#6B85B8">Réalisé</text>
  <rect x="434" y="136" width="222" height="142" rx="8" fill="#152232"/>
  <text x="450" y="157" font-family="Arial,sans-serif" font-size="11" fill="#C8D8F0" font-weight="600">Trésorerie (k FCFA)</text>
  <polyline points="450,250 480,240 510,245 540,225 570,215 600,205 630,198" fill="none" stroke="#1D9E75" stroke-width="2" stroke-linejoin="round"/>
  <polyline points="450,265 480,260 510,255 540,252 570,248 600,242 630,238" fill="none" stroke="#378ADD" stroke-width="1.5" stroke-dasharray="4,3" stroke-linejoin="round"/>
  <circle cx="630" cy="198" r="3" fill="#1D9E75"/>
  <text x="636" y="202" font-family="Arial,sans-serif" font-size="8" fill="#4ADE80">+18%</text>
  <line x1="450" y1="268" x2="636" y2="268" stroke="#1E3050" stroke-width="0.5"/>
  <text x="450" y="280" font-family="Arial,sans-serif" font-size="8" fill="#4A6090">Jan</text>
  <text x="510" y="280" font-family="Arial,sans-serif" font-size="8" fill="#4A6090">Mar</text>
  <text x="570" y="280" font-family="Arial,sans-serif" font-size="8" fill="#4A6090">Mai</text>
  <text x="620" y="280" font-family="Arial,sans-serif" font-size="8" fill="#4A6090">Jul</text>
  <rect x="450" y="290" width="8" height="2" rx="1" fill="#1D9E75"/>
  <text x="462" y="296" font-family="Arial,sans-serif" font-size="8" fill="#6B85B8">Tréso.</text>
  <rect x="500" y="290" width="8" height="2" rx="1" fill="#378ADD"/>
  <text x="512" y="296" font-family="Arial,sans-serif" font-size="8" fill="#6B85B8">Objectif</text>
</svg>`,
  },
  {
    label: "Tableau de bord Supply Chain",
    svg: `<svg width="100%" viewBox="0 0 680 300" xmlns="http://www.w3.org/2000/svg">
  <rect width="680" height="300" fill="#0F1E14"/>
  <rect width="680" height="4" fill="#E8440A"/>
  <text x="24" y="32" font-family="Arial,sans-serif" font-size="13" fill="#C8D8F0" font-weight="700">Tableau de bord Supply Chain</text>
  <text x="24" y="48" font-family="Arial,sans-serif" font-size="10" fill="#4A6090">Stocks · Commandes · Livraisons · Fournisseurs</text>
  <rect x="24" y="60" width="148" height="62" rx="8" fill="#162214"/>
  <rect x="24" y="60" width="3" height="62" rx="1.5" fill="#1D9E75"/>
  <text x="36" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">Taux de service</text>
  <text x="36" y="104" font-family="Arial,sans-serif" font-size="26" fill="#4ADE80" font-weight="700">94.2%</text>
  <text x="36" y="116" font-family="Arial,sans-serif" font-size="9" fill="#4ADE80">Objectif : 95%</text>
  <rect x="182" y="60" width="148" height="62" rx="8" fill="#162214"/>
  <rect x="182" y="60" width="3" height="62" rx="1.5" fill="#E8440A"/>
  <text x="194" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">Commandes en cours</text>
  <text x="194" y="104" font-family="Arial,sans-serif" font-size="26" fill="#FFFFFF" font-weight="700">342</text>
  <text x="194" y="116" font-family="Arial,sans-serif" font-size="9" fill="#FCA5A5">18 en retard</text>
  <rect x="340" y="60" width="148" height="62" rx="8" fill="#162214"/>
  <rect x="340" y="60" width="3" height="62" rx="1.5" fill="#EF9F27"/>
  <text x="352" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">Délai moyen livr.</text>
  <text x="352" y="104" font-family="Arial,sans-serif" font-size="26" fill="#EF9F27" font-weight="700">3.8 j</text>
  <text x="352" y="116" font-family="Arial,sans-serif" font-size="9" fill="#4ADE80">↓ 0.6j vs M-1</text>
  <rect x="498" y="60" width="158" height="62" rx="8" fill="#162214"/>
  <rect x="498" y="60" width="3" height="62" rx="1.5" fill="#378ADD"/>
  <text x="510" y="79" font-family="Arial,sans-serif" font-size="10" fill="#8EA8D8">Valeur stock (FCFA)</text>
  <text x="510" y="104" font-family="Arial,sans-serif" font-size="22" fill="#FFFFFF" font-weight="700">1.8 Mds</text>
  <text x="510" y="116" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8">Rotation : 4.2x</text>
  <rect x="24" y="136" width="200" height="142" rx="8" fill="#162214"/>
  <text x="40" y="157" font-family="Arial,sans-serif" font-size="11" fill="#C8D8F0" font-weight="600">Stock par entrepôt</text>
  <text x="40" y="178" font-family="Arial,sans-serif" font-size="9" fill="#6B85B8">Douala</text>
  <rect x="40" y="183" width="164" height="10" rx="3" fill="#1E3A1E"/>
  <rect x="40" y="183" width="131" height="10" rx="3" fill="#1D9E75"/>
  <text x="208" y="192" font-family="Arial,sans-serif" font-size="9" fill="#4ADE80" text-anchor="end">80%</text>
  <text x="40" y="206" font-family="Arial,sans-serif" font-size="9" fill="#6B85B8">Yaoundé</text>
  <rect x="40" y="211" width="164" height="10" rx="3" fill="#1E3A1E"/>
  <rect x="40" y="211" width="107" height="10" rx="3" fill="#378ADD"/>
  <text x="208" y="220" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8" text-anchor="end">65%</text>
  <text x="40" y="234" font-family="Arial,sans-serif" font-size="9" fill="#6B85B8">Bafoussam</text>
  <rect x="40" y="239" width="164" height="10" rx="3" fill="#1E3A1E"/>
  <rect x="40" y="239" width="74" height="10" rx="3" fill="#EF9F27"/>
  <text x="208" y="248" font-family="Arial,sans-serif" font-size="9" fill="#EF9F27" text-anchor="end">45%</text>
  <text x="40" y="262" font-family="Arial,sans-serif" font-size="9" fill="#6B85B8">Garoua</text>
  <rect x="40" y="267" width="164" height="10" rx="3" fill="#1E3A1E"/>
  <rect x="40" y="267" width="41" height="10" rx="3" fill="#E24B4A"/>
  <text x="208" y="276" font-family="Arial,sans-serif" font-size="9" fill="#FCA5A5" text-anchor="end">25% ⚠</text>
  <rect x="234" y="136" width="222" height="142" rx="8" fill="#162214"/>
  <text x="250" y="157" font-family="Arial,sans-serif" font-size="11" fill="#C8D8F0" font-weight="600">Livraisons mensuelles</text>
  <line x1="250" y1="260" x2="440" y2="260" stroke="#1E3A1E" stroke-width="0.5"/>
  <line x1="250" y1="240" x2="440" y2="240" stroke="#1E3A1E" stroke-width="0.5"/>
  <line x1="250" y1="220" x2="440" y2="220" stroke="#1E3A1E" stroke-width="0.5"/>
  <polyline points="258,248 285,238 312,242 339,228 366,222 393,215 420,208 440,202" fill="none" stroke="#1D9E75" stroke-width="2" stroke-linejoin="round"/>
  <polyline points="258,255 285,250 312,252 339,245 366,242 393,238 420,234 440,230" fill="none" stroke="#E8440A" stroke-width="1.5" stroke-dasharray="4,3" stroke-linejoin="round"/>
  <circle cx="440" cy="202" r="3" fill="#1D9E75"/>
  <text x="258" y="272" font-family="Arial,sans-serif" font-size="8" fill="#4A6090">Jan</text>
  <text x="312" y="272" font-family="Arial,sans-serif" font-size="8" fill="#4A6090">Mar</text>
  <text x="366" y="272" font-family="Arial,sans-serif" font-size="8" fill="#4A6090">Mai</text>
  <text x="420" y="272" font-family="Arial,sans-serif" font-size="8" fill="#4A6090">Jul</text>
  <rect x="466" y="136" width="190" height="142" rx="8" fill="#162214"/>
  <text x="482" y="157" font-family="Arial,sans-serif" font-size="11" fill="#C8D8F0" font-weight="600">Top fournisseurs</text>
  <text x="482" y="176" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8">SABC Cameroun</text>
  <text x="644" y="176" font-family="Arial,sans-serif" font-size="9" fill="#4ADE80" text-anchor="end">98% ✓</text>
  <text x="482" y="194" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8">Groupe Bolloré</text>
  <text x="644" y="194" font-family="Arial,sans-serif" font-size="9" fill="#4ADE80" text-anchor="end">95% ✓</text>
  <text x="482" y="212" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8">Orange CMR</text>
  <text x="644" y="212" font-family="Arial,sans-serif" font-size="9" fill="#EF9F27" text-anchor="end">87% ~</text>
  <text x="482" y="230" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8">MTN Business</text>
  <text x="644" y="230" font-family="Arial,sans-serif" font-size="9" fill="#EF9F27" text-anchor="end">82% ~</text>
  <text x="482" y="248" font-family="Arial,sans-serif" font-size="9" fill="#8EA8D8">Fournisseur E</text>
  <text x="644" y="248" font-family="Arial,sans-serif" font-size="9" fill="#FCA5A5" text-anchor="end">61% ✗</text>
  <text x="482" y="270" font-family="Arial,sans-serif" font-size="9" fill="#4A6090">Score de fiabilité moyen</text>
  <text x="482" y="284" font-family="Arial,sans-serif" font-size="14" fill="#FFFFFF" font-weight="700">84.6%</text>
</svg>`,
  },
];

// ═════════════════════════════════════════════════════════════════════════════
//  DONNÉES DU FORMULAIRE
// ═════════════════════════════════════════════════════════════════════════════
const STEPS = [
  {
    label: "Partie 1 — Profil & rapport à Excel",
    questions: [
      { id:"nom", type:"text", required:true,
        q:"Nom",
        placeholder:"Ex : Dupont" },
      { id:"prenom", type:"text", required:true,
        q:"Prénom",
        placeholder:"Ex : Marie" },
      { id:"poste", type:"text", required:true,
        q:"Poste / Fonction",
        placeholder:"Ex : Responsable RH" },
      { id:"duree", type:"radio", required:true,
        q:"Depuis combien de temps utilisez-vous Excel ?",
        opts:["Moins de 6 mois","6 mois à 2 ans","2 à 5 ans","Plus de 5 ans"] },
      { id:"freq", type:"radio", required:true,
        q:"À quelle fréquence utilisez-vous Excel ?",
        opts:["Plusieurs fois par jour","Tous les jours","Quelques fois par semaine","Occasionnellement"] },
      { id:"niveau", type:"rating", required:true,
        q:"Évaluez votre niveau actuel sur Excel",
        sub:"1 = Débutant complet  ·  5 = Expert autonome",
        scale:["1","2","3","4","5"] },
    ],
  },
  {
    label: "Partie 2 — Inventaire de compétences",
    questions: [
      { id:"prod", type:"check", cols:2,
        q:"Quels types de fichiers Excel produisez-vous actuellement ?",
        opts:["Tableaux simples (listes, saisies)","Formules de base (SOMME, MOYENNE)",
              "Formules avancées (SI, RECHERCHEV)","Tableaux Croisés Dynamiques",
              "Graphiques","Tableaux de bord","Power Query","Connexions ERP / BDD"] },
      { id:"fonctions", type:"check", cols:2,
        q:"Fonctions utilisées régulièrement en autonomie :",
        opts:["SOMME.SI / SOMME.SI.ENS","NB.SI / NBVAL","SI imbriqué / ET / OU",
              "RECHERCHEV / RECHERCHEX","INDEX / EQUIV",
              "Fonctions de dates (DATEDIF, NB.JOURS.OUVRES)",
              "Mise en forme conditionnelle","Aucune de ces fonctions"] },
      { id:"tcd", type:"radio", required:true,
        q:"Avez-vous déjà créé un Tableau Croisé Dynamique (TCD) ?",
        opts:["Non, jamais","Oui, avec de l'aide",
              "Oui, de façon autonome (basique)","Oui, avec champs calculés et segments"] },
      { id:"pq", type:"radio", required:true,
        q:"Avez-vous déjà utilisé Power Query ?",
        opts:["Non, je ne connais pas","J'en ai entendu parler sans l'utiliser",
              "Oui, pour des opérations simples","Oui, avec transformations et croisements"] },
    ],
  },
  {
    label: "Partie 3 — Besoins concrets",
    questions: [
      { id:"difficulte", type:"textarea", required:true,
        q:"Quelle est votre principale difficulté avec Excel aujourd'hui ?",
        placeholder:"Ex : Je perds du temps à consolider des fichiers manuellement chaque mois..." },
      { id:"objectif", type:"textarea", required:true,
        q:"Qu'est-ce qui aurait concrètement changé après cette formation ?",
        placeholder:"Ex : Mon rapport RH mensuel en 10 min au lieu de 3 heures..." },
      { id:"priorites", type:"check", cols:2,
        q:"Vos sujets prioritaires :",
        opts:["Fonctions avancées (SOMME.SI, RECHERCHEX)","Tableaux Croisés Dynamiques",
              "Visualisation & choix des graphiques","Conception d'un tableau de bord complet",
              "Définition des KPI métiers","Power Query — nettoyage des données",
              "Power Query — croisement de sources","Automatisation des rapports"] },
    ],
  },
  {
    label: "Partie 4 — Vos données métiers",
    questions: [
      { id:"domaine", type:"check_with_other", cols:1,
        q:"Sur quel type de données travaillez-vous principalement ?",
        opts:["RH (effectifs, paie, absences, formations, ancienneté)",
              "Comptabilité / Finance (budgets, facturation, états financiers)",
              "Supply Chain (stocks, commandes, livraisons, fournisseurs)",
              "Commercial / Ventes","Projets / Plannings"],
        otherLabel:"Autres",
        otherPlaceholder:"Précisez votre domaine..." },
      { id:"volume", type:"radio", required:true,
        q:"Volume habituel de vos fichiers de travail :",
        opts:["Moins de 500 lignes","500 à 5 000 lignes","5 000 à 50 000 lignes","Plus de 50 000 lignes"] },
      { id:"sources", type:"check", cols:2,
        q:"Vos données proviennent de :",
        opts:["Un seul fichier Excel","Plusieurs fichiers Excel",
              "Un ERP ou logiciel métier (SAP, Sage, Odoo…)",
              "Une base de données (Access, SQL…)","Sources mixtes (CSV, web, Excel, BDD)"] },
      { id:"partage", type:"radio", required:true,
        q:"Accepteriez-vous de partager un fichier anonymisé pour les exercices ?",
        sub:"Cela rend la formation immédiatement applicable à votre poste",
        opts:["Oui, sans problème","Oui, après anonymisation","Non","Je ne sais pas encore"] },
    ],
  },
  {
    label: "Partie 5 — Style d'apprentissage",
    questions: [
      { id:"style", type:"radio", required:true,
        q:"Quel style de formation vous convient le mieux ?",
        opts:["Théorie complète avant de pratiquer",
              "Équilibre : théorie courte + pratique immédiate",
              "Démarrer directement par la pratique","Je m'adapte facilement"] },
      { id:"apprentissage", type:"check", cols:2,
        q:"Comment préférez-vous apprendre ?",
        opts:["En reproduisant les étapes du formateur","En résolvant des exercices en autonomie",
              "En travaillant en binôme ou en groupe","En apportant mes propres données et cas"] },
      { id:"autres", type:"textarea",
        q:"Un sujet spécifique que vous souhaitez absolument aborder ?",
        placeholder:"Optionnel — laissez vide si rien à ajouter..." },
    ],
  },
];

// ═════════════════════════════════════════════════════════════════════════════
//  STYLES
// ═════════════════════════════════════════════════════════════════════════════
const N = "#1E2A5E", O = "#E8440A";

const S = {
  wrap:{ maxWidth:700, margin:"0 auto", padding:"0 1rem 4rem",
         fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif",
         color:"#1A1A2A", overflowX:"clip" },
  carouselWrap:{ position:"sticky", top:0, zIndex:100,
                 marginBottom:"1.5rem", overflow:"hidden", background:N,
                 boxShadow:"0 4px 24px rgba(0,0,0,0.32)" },
  carouselInner:(idx)=>({ display:"flex", transform:`translateX(-${idx*100}%)`,
                           transition:"transform .5s cubic-bezier(.4,0,.2,1)" }),
  carouselSlide:{ minWidth:"100%", flexShrink:0 },
  carouselBtn:(side)=>({ position:"absolute", top:"50%",
                          [side==="left"?"left":"right"]: 12,
                          transform:"translateY(-50%)",
                          width:32, height:32, borderRadius:"50%",
                          background:"rgba(0,0,0,.45)", border:"1px solid rgba(255,255,255,.2)",
                          color:"#fff", fontSize:16, cursor:"pointer",
                          display:"flex", alignItems:"center", justifyContent:"center",
                          zIndex:2, transition:"background .15s" }),
  carouselDots:{ display:"flex", justifyContent:"center", gap:6,
                  padding:"10px 0 6px", background:N },
  dot:(active)=>({ width: active?20:6, height:6, borderRadius:3,
                    background: active?"#E8440A":"rgba(255,255,255,.3)",
                    transition:"all .3s", cursor:"pointer" }),
  carouselLabel:{ textAlign:"center", background:N,
                   padding:"0 0 12px",
                   fontSize:11, color:"rgba(255,255,255,.5)",
                   letterSpacing:".04em", fontWeight:500 },
  hero:{ background:N, color:"#fff", borderRadius:12,
         padding:"1.75rem 2rem", marginBottom:"1.5rem", borderTop:`5px solid ${O}` },
  progressWrap:{ height:5, background:"#E5E7EB", borderRadius:3,
                 marginBottom:"1.5rem", overflow:"hidden" },
  progressFill:(p)=>({ height:"100%", background:O, borderRadius:3,
                        width:`${p}%`, transition:"width .4s ease" }),
  sectionLabel:{ fontSize:11, fontWeight:600, color:"#6B7280",
                 textTransform:"uppercase", letterSpacing:".08em",
                 margin:"0 0 .75rem", paddingBottom:".5rem",
                 borderBottom:"1px solid #E5E7EB" },
  card:{ background:"#fff", border:"1px solid #E5E7EB", borderRadius:12,
         padding:"1.25rem", marginBottom:".75rem" },
  qNum:{ fontSize:11, color:O, fontWeight:600, marginBottom:4 },
  qText:{ fontSize:15, fontWeight:600, color:N, marginBottom:4, lineHeight:1.5 },
  qSub:{ fontSize:13, color:"#6B7280", marginBottom:12 },
  grid:(c)=>({ display:"grid", gridTemplateColumns:c===2?"repeat(2,minmax(0,1fr))":"1fr", gap:6 }),
  opt:(s)=>({ display:"flex", alignItems:"center", gap:10, padding:"9px 13px",
              border:`1px solid ${s?O:"#E5E7EB"}`, borderRadius:8, cursor:"pointer",
              background:s?"#FFF5F2":"#fff", fontSize:14, color:"#1A1A2A",
              userSelect:"none", transition:"all .15s" }),
  indicator:(s,radio)=>({ width:16, height:16, borderRadius:radio?"50%":4, flexShrink:0,
                           border:`2px solid ${s?O:"#D1D5DB"}`,
                           background:s?O:"transparent",
                           display:"flex", alignItems:"center", justifyContent:"center",
                           transition:"all .15s" }),
  ratingBtn:(s)=>({ width:40, height:40, borderRadius:8,
                    border:`1px solid ${s?O:"#E5E7EB"}`,
                    background:s?O:"#fff", color:s?"#fff":"#6B7280",
                    fontSize:13, fontWeight:s?600:400, cursor:"pointer",
                    transition:"all .15s" }),
  textInput:{ width:"100%", border:"1px solid #E5E7EB", borderRadius:8,
              padding:"10px 12px", fontSize:14, fontFamily:"inherit",
              color:"#1A1A2A", background:"#fff", outline:"none",
              boxSizing:"border-box", transition:"border-color .15s" },
  textarea:{ width:"100%", border:"1px solid #E5E7EB", borderRadius:8,
             padding:"10px 12px", fontSize:14, fontFamily:"inherit",
             color:"#1A1A2A", background:"#fff", outline:"none",
             resize:"vertical", minHeight:80, lineHeight:1.6,
             boxSizing:"border-box", transition:"border-color .15s" },
  otherInput:{ marginTop:8, width:"100%", border:"1px solid #E5E7EB",
               borderRadius:8, padding:"9px 12px", fontSize:13,
               fontFamily:"inherit", color:"#1A1A2A", background:"#F9FAFB",
               outline:"none", boxSizing:"border-box", transition:"border-color .15s" },
  errMsg:{ fontSize:12, color:"#DC2626", marginTop:6, display:"flex",
           alignItems:"center", gap:5 },
  nav:{ display:"flex", gap:10, alignItems:"center", marginTop:"1.5rem" },
  btnNext:(d)=>({ flex:1, background:d?"#9CA3AF":O, color:"#fff", border:"none",
                  borderRadius:8, padding:"12px 28px", fontSize:14, fontWeight:600,
                  cursor:d?"not-allowed":"pointer", transition:"all .15s" }),
  btnBack:{ background:"#fff", color:"#6B7280", border:"1px solid #E5E7EB",
            borderRadius:8, padding:"12px 20px", fontSize:14, cursor:"pointer" },
  stepInfo:{ fontSize:12, color:"#6B7280", flexShrink:0 },
  toastWrap:{ borderRadius:10, padding:"14px 18px", marginTop:"1rem",
              display:"flex", gap:12, alignItems:"flex-start", fontSize:14,
              lineHeight:1.5 },
  toast:(ok)=>({ background: ok?"#F0FFF4":"#FEF2F2",
                  border:`1px solid ${ok?"#BBF7D0":"#FECACA"}`,
                  color: ok?"#14532D":"#991B1B" }),
  successWrap:{ textAlign:"center", padding:"3rem 1.5rem" },
  successCircle:{ width:72, height:72, borderRadius:"50%", background:"#F0FFF4",
                  display:"flex", alignItems:"center", justifyContent:"center",
                  margin:"0 auto 1.25rem", border:"2px solid #BBF7D0" },
};

// ═════════════════════════════════════════════════════════════════════════════
//  CAROUSEL COMPONENT
// ═════════════════════════════════════════════════════════════════════════════
function DashboardCarousel() {
  const [idx, setIdx] = useState(0);
  const intervalRef = useRef(null);

  const go = useCallback((dir) => {
    setIdx((i) => (i + dir + DASHBOARDS.length) % DASHBOARDS.length);
  }, []);

  useEffect(() => {
    intervalRef.current = setInterval(() => go(1), 4000);
    return () => clearInterval(intervalRef.current);
  }, [go]);

  const pause = () => clearInterval(intervalRef.current);
  const resume = () => { intervalRef.current = setInterval(() => go(1), 4000); };

  return (
    <div style={S.carouselWrap} onMouseEnter={pause} onMouseLeave={resume}>
      <div style={{ overflow:"hidden" }}>
        <div style={S.carouselInner(idx)}>
          {DASHBOARDS.map((d, i) => (
            <div key={i} style={S.carouselSlide}
              dangerouslySetInnerHTML={{ __html: d.svg }} />
          ))}
        </div>
      </div>

      <button style={S.carouselBtn("left")} onClick={() => go(-1)}
        onMouseEnter={(e) => e.currentTarget.style.background="rgba(0,0,0,.7)"}
        onMouseLeave={(e) => e.currentTarget.style.background="rgba(0,0,0,.45)"}>
        ‹
      </button>
      <button style={S.carouselBtn("right")} onClick={() => go(1)}
        onMouseEnter={(e) => e.currentTarget.style.background="rgba(0,0,0,.7)"}
        onMouseLeave={(e) => e.currentTarget.style.background="rgba(0,0,0,.45)"}>
        ›
      </button>

      <div style={S.carouselDots}>
        {DASHBOARDS.map((_, i) => (
          <div key={i} style={S.dot(i===idx)} onClick={() => setIdx(i)} />
        ))}
      </div>
      <div style={S.carouselLabel}>{DASHBOARDS[idx].label}</div>
    </div>
  );
}

// ═════════════════════════════════════════════════════════════════════════════
//  TOAST / FEEDBACK
// ═════════════════════════════════════════════════════════════════════════════
function Toast({ ok, message }) {
  if (!message) return null;
  return (
    <div style={{ ...S.toastWrap, ...S.toast(ok) }}>
      {ok
        ? <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{flexShrink:0,marginTop:1}}>
            <circle cx="9" cy="9" r="7.5" stroke="#16A34A" strokeWidth="1.5"/>
            <polyline points="5.5,9 8,11.5 12.5,6" stroke="#16A34A" strokeWidth="1.5"
              strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        : <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{flexShrink:0,marginTop:1}}>
            <circle cx="9" cy="9" r="7.5" stroke="#DC2626" strokeWidth="1.5"/>
            <path d="M9 5.5v4M9 12h.01" stroke="#DC2626" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
      }
      <span>{message}</span>
    </div>
  );
}

// ═════════════════════════════════════════════════════════════════════════════
//  QUESTION CARD
// ═════════════════════════════════════════════════════════════════════════════
function Dot({ sel, radio }) {
  return (
    <div style={S.indicator(sel, radio)}>
      {sel && (radio
        ? <div style={{ width:6, height:6, borderRadius:"50%", background:"#fff" }} />
        : <svg width="9" height="7" viewBox="0 0 9 7" fill="none">
            <polyline points="1,3.5 3.5,6 8,1" stroke="#fff"
              strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
      )}
    </div>
  );
}

function QuestionCard({ q, value, otherValue, onChange, onOtherChange, error }) {
  const focus = (e) => { e.target.style.borderColor = O; };
  const blur  = (e) => { e.target.style.borderColor = "#E5E7EB"; };

  const toggleCheck = useCallback((opt) => {
    const arr = Array.isArray(value) ? [...value] : [];
    const i = arr.indexOf(opt);
    i > -1 ? arr.splice(i, 1) : arr.push(opt);
    onChange(arr);
  }, [value, onChange]);

  const isOtherSelected = q.type === "check_with_other"
    && Array.isArray(value) && value.includes(q.otherLabel || "Autres");

  return (
    <div style={S.card}>
      <div style={S.qNum}>Question</div>
      <div style={S.qText}>
        {q.q}{q.required && <span style={{ color:O }}> *</span>}
      </div>
      {q.sub && <div style={S.qSub}>{q.sub}</div>}

      {/* RADIO */}
      {q.type === "radio" && (
        <div style={S.grid(1)}>
          {q.opts.map((opt) => (
            <div key={opt} style={S.opt(value===opt)} onClick={() => onChange(opt)}>
              <Dot sel={value===opt} radio />
              <span>{opt}</span>
            </div>
          ))}
        </div>
      )}

      {/* CHECK */}
      {q.type === "check" && (
        <div style={S.grid(q.cols||1)}>
          {q.opts.map((opt) => {
            const sel = Array.isArray(value) && value.includes(opt);
            return (
              <div key={opt} style={S.opt(sel)} onClick={() => toggleCheck(opt)}>
                <Dot sel={sel} radio={false} />
                <span>{opt}</span>
              </div>
            );
          })}
        </div>
      )}

      {/* CHECK WITH OTHER — champ texte si "Autres" coché */}
      {q.type === "check_with_other" && (
        <>
          <div style={S.grid(q.cols||1)}>
            {q.opts.map((opt) => {
              const sel = Array.isArray(value) && value.includes(opt);
              return (
                <div key={opt} style={S.opt(sel)} onClick={() => toggleCheck(opt)}>
                  <Dot sel={sel} radio={false} />
                  <span>{opt}</span>
                </div>
              );
            })}
            {/* Option "Autres" */}
            {(() => {
              const lbl = q.otherLabel || "Autres";
              const sel = Array.isArray(value) && value.includes(lbl);
              return (
                <div style={S.opt(sel)} onClick={() => toggleCheck(lbl)}>
                  <Dot sel={sel} radio={false} />
                  <span>{lbl}</span>
                </div>
              );
            })()}
          </div>
          {/* Champ texte affiché uniquement si "Autres" est coché */}
          {isOtherSelected && (
            <input
              type="text"
              style={{ ...S.otherInput }}
              value={otherValue || ""}
              placeholder={q.otherPlaceholder || "Précisez..."}
              onChange={(e) => onOtherChange(e.target.value)}
              onFocus={(e) => { e.target.style.borderColor = O; }}
              onBlur={(e)  => { e.target.style.borderColor = "#E5E7EB"; }}
              autoFocus
            />
          )}
        </>
      )}

      {/* RATING */}
      {q.type === "rating" && (
        <div style={{ display:"flex", alignItems:"center", gap:10, padding:"6px 0" }}>
          <div style={{ fontSize:13, color:"#6B7280", width:120, flexShrink:0 }}>Mon niveau</div>
          <div style={{ display:"flex", gap:6 }}>
            {q.scale.map((v) => (
              <button key={v} style={S.ratingBtn(value===v)} onClick={() => onChange(v)}>{v}</button>
            ))}
          </div>
        </div>
      )}

      {/* TEXT */}
      {q.type === "text" && (
        <input style={S.textInput} type="text"
          value={value||""} placeholder={q.placeholder||""}
          onChange={(e) => onChange(e.target.value)}
          onFocus={focus} onBlur={blur}
        />
      )}

      {/* TEXTAREA */}
      {q.type === "textarea" && (
        <textarea style={S.textarea}
          value={value||""} placeholder={q.placeholder||""}
          onChange={(e) => onChange(e.target.value)}
          onFocus={focus} onBlur={blur}
        />
      )}

      {error && (
        <div style={S.errMsg}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{flexShrink:0}}>
            <circle cx="7" cy="7" r="6" stroke="#DC2626" strokeWidth="1.2"/>
            <path d="M7 4.5v3M7 9.5h.01" stroke="#DC2626" strokeWidth="1.2" strokeLinecap="round"/>
          </svg>
          {error}
        </div>
      )}
    </div>
  );
}

// ═════════════════════════════════════════════════════════════════════════════
//  COMPOSANT PRINCIPAL
// ═════════════════════════════════════════════════════════════════════════════
export default function Questionnaire() {
  const [step,      setStep]      = useState(0);
  const [answers,   setAnswers]   = useState({});
  const [otherVals, setOtherVals] = useState({});
  const [errors,    setErrors]    = useState({});
  const [sending,   setSending]   = useState(false);
  const [done,      setDone]      = useState(false);
  const [toast,     setToast]     = useState({ ok:true, msg:"" });

  const total   = STEPS.length;
  const current = STEPS[step];
  const pct     = Math.round(((step + 1) / total) * 100);

  const handleChange = useCallback((id, val) => {
    setAnswers((p) => ({ ...p, [id]: val }));
    setErrors((p)  => { const n = { ...p }; delete n[id]; return n; });
  }, []);

  const handleOther = useCallback((id, val) => {
    setOtherVals((p) => ({ ...p, [id]: val }));
  }, []);

  const validate = () => {
    const errs = {};
    current.questions.forEach((q) => {
      if (!q.required) return;
      const v = answers[q.id];
      if ((q.type==="text"||q.type==="textarea") && !(v||"").trim())
        errs[q.id] = "Ce champ est obligatoire.";
      if (q.type==="radio" && !v)
        errs[q.id] = "Veuillez sélectionner une réponse.";
      if (q.type==="rating" && !v)
        errs[q.id] = "Veuillez noter votre niveau.";
    });
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const scrollTop = () => window.scrollTo({ top: 0, behavior:"smooth" });

  const next = async () => {
    if (!validate()) return;
    if (step < total - 1) { setStep((s) => s + 1); scrollTop(); }
    else await submit();
  };

  const submit = async () => {
    setSending(true);
    setToast({ ok:true, msg:"" });

    const toStr = (v) => Array.isArray(v) ? v.join(" | ") : (v ?? "");

    const payload = {
      ...Object.fromEntries(
        Object.entries(answers).map(([k, v]) => [k, toStr(v)])
      ),
      ...Object.fromEntries(
        Object.entries(otherVals).map(([k, v]) => [`${k}_autre`, v])
      ),
    };

    try {
      const res = await fetch(API_URL, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify(payload),
      });

      const json = await res.json().catch(() => ({}));

      if (res.ok && json.status === "ok") {
        setDone(true);
      } else {
        setToast({
          ok:  false,
          msg: json.message || `Erreur ${res.status}. Vérifiez que le serveur Flask est bien démarré.`,
        });
      }
    } catch (err) {
      setToast({
        ok:  false,
        msg: "Impossible de joindre le serveur. Vérifiez votre connexion et l'URL de l'API.",
      });
    } finally {
      setSending(false);
    }
  };

  // ── Écran de succès ─────────────────────────────────────────────────────────
  if (done) return (
    <div style={S.wrap}>
      <DashboardCarousel />
      <div style={S.successWrap}>
        <div style={S.successCircle}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
            stroke="#16A34A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>
        <h2 style={{ fontSize:22, fontWeight:600, color:N, marginBottom:".75rem" }}>
          Réponses enregistrées
        </h2>
        <p style={{ fontSize:14, color:"#6B7280", lineHeight:1.7 }}>
          Vos réponses ont bien été sauvegardées.<br/>
          Le programme sera adapté en fonction de vos réponses.<br/><br/>
          <strong style={{ color:N }}>Proxima Technologies — Formation sur mesure.</strong>
        </p>
      </div>
    </div>
  );

  // ── Formulaire ─────────────────────────────────────────────────────────────
  return (
    <div style={S.wrap}>
      <DashboardCarousel />

      <div style={S.hero}>
        <h1 style={{ fontSize:20, fontWeight:600, marginBottom:4 }}>{FORM_TITLE}</h1>
        <p style={{ fontSize:14, opacity:.72, margin:0 }}>{FORM_SUB}</p>
      </div>

      <div style={S.progressWrap}><div style={S.progressFill(pct)}/></div>
      <div style={S.sectionLabel}>{current.label}</div>

      {current.questions.map((q) => (
        <QuestionCard key={q.id} q={q}
          value={answers[q.id]}
          otherValue={otherVals[q.id]}
          onChange={(v) => handleChange(q.id, v)}
          onOtherChange={(v) => handleOther(q.id, v)}
          error={errors[q.id]}
        />
      ))}

      <Toast ok={toast.ok} message={toast.msg} />

      <div style={S.nav}>
        {step > 0 && (
          <button style={S.btnBack}
            onClick={() => { setStep((s) => s-1); scrollTop(); }}>
            Précédent
          </button>
        )}
        <button style={S.btnNext(sending)} onClick={next} disabled={sending}>
          {sending
            ? "Enregistrement..."
            : step === total-1
            ? "Envoyer mes réponses"
            : "Suivant"}
        </button>
        <div style={S.stepInfo}>Étape {step+1} / {total}</div>
      </div>
    </div>
  );
}
